module.exports = "/images/bonus_arrow.svg?801e08279df42e03f1821c1ac89371c2";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/bonus_arrow.svg
// module id = 64
// module chunks = 0